import React, { useEffect, useCallback } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { collection, getDocs, query } from 'firebase/firestore';
import { db } from 'src/firebase';

const useIsAdmin = () => {
  const auth = getAuth();
  const [user, setUser] = React.useState(null);
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [firebaseAuthLoading, setFirebaseAuthLoading] = React.useState(true);
  const [loading, setLoading] = React.useState(true);
  const [adminUserIds, setAdminUserIds] = React.useState([]);

  onAuthStateChanged(auth, (user) => {
    if (firebaseAuthLoading) {
      if (user) {
        setUser(user);
      }
      setFirebaseAuthLoading(false);
    }
  });

  const fetchAdminUserIds = useCallback(async () => {
    if (!firebaseAuthLoading) return;

    const q = await query(collection(db, 'admins'));
    const snapshot = await getDocs(q);
    setAdminUserIds(snapshot.docs.map((doc) => doc.data().userId));
  }, [firebaseAuthLoading]);

  useEffect(() => {
    fetchAdminUserIds();
  }, [fetchAdminUserIds]);

  useEffect(() => {
    if (!firebaseAuthLoading && adminUserIds.length > 0) {
      setIsAdmin(adminUserIds.includes(user?.uid || 'fake-id'));
      setLoading(false);
    }
  }, [user, adminUserIds, firebaseAuthLoading]);

  return { loading, user, isAdmin, isLoggedIn: !!user };
};

export default useIsAdmin;
